import { ReactNode, useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Header } from 'shared/ui/header'

import s from './styles.module.scss'

interface SearchParamsHeaderViewProps {
  onGoBack: () => void
  destination?: string
  dates?: string
  nights?: number
  guests?: number
  actionRight?: ReactNode
  onEditSearch?: () => void
}

export const SearchParamsHeaderView = ({
  onGoBack,
  destination,
  dates,
  nights,
  guests,
  actionRight,
  onEditSearch,
}: SearchParamsHeaderViewProps) => {
  const { t } = useTranslation()

  const subtitle = useMemo(() => {
    const parts = []
    if (dates) parts.push(dates)
    if (nights) {
      parts.push(t('kyrgyzstan_block.search_result.nights', { count: nights }))
    }
    if (guests) {
      parts.push(t('kyrgyzstan_block.search_result.guests', { count: guests }))
    }
    return parts.join(' • ')
  }, [dates, nights, guests, t])

  const resolvedActionRight =
    actionRight ??
    (onEditSearch ? (
      <button
        type="button"
        className={s.editButton}
        onClick={onEditSearch}
      >
        <AppIcon
          width={20}
          height={20}
          className={s.icon}
          id={AllIcons.PENCIL}
          color="var(--blue-5)"
        />
      </button>
    ) : undefined)

  const BackButton = (
    <button
      type="button"
      onClick={onGoBack}
      className={s.backButton}
    >
      <AppIcon
        width={24}
        height={24}
        className={s.icon}
        id={AllIcons.ARROW_LEFT}
      />
    </button>
  )

  const centerInner = (
    <>
      {destination && (
        <span className={clsx('bold-14', s.title)}>{destination}</span>
      )}
      {subtitle && (
        <span className={clsx('medium-12', s.subtitle)}>{subtitle}</span>
      )}
    </>
  )

  const center = onEditSearch ? (
    <button
      type="button"
      className={clsx(s.content, s.contentButton)}
      onClick={onEditSearch}
    >
      {centerInner}
    </button>
  ) : (
    <div className={s.content}>{centerInner}</div>
  )

  return (
    <div
      className={s.header}
      id={'search-params-header'}
    >
      <Header
        isFixed={true}
        actionLeft={BackButton}
        actionRight={resolvedActionRight}
      >
        {center}
      </Header>
    </div>
  )
}
